import { cert } from '@zap-onboard/api-client';
import { useHandlerQuery } from '../../useHandlerQuery';

export const useMyCertOverview = (
  args: Parameters<cert.Client['getMyOverview']>[0],
) =>
  useHandlerQuery((api) => api.cert().getMyOverview(args), {
    key: ['MY_CERT_SUMMARIES', args],
  });
